import React, { useState } from "react";
import { useSimplicityImage } from "cms/images/hooks/use-simplicity-image";
import { CarouselImageSettingsDialog } from "cms/components/components/hero-carousel/edit/image/image-settings-dialog";
import { ImageSelectorDisplay } from "cms/components/components/hero-carousel/edit/image/image-selector-display";
import { ImageSelectorButton } from "cms/components/components/hero-carousel/edit/image/image-selector-button";
import { Logger } from "cms/utils/log/logger";

/**
 *
 *    This is the image portion of the carousel editor component
 *
 *
 * */
const CarouselImageEditor = (props) => {

    const {
        image,
        setImage,
        settings,
        setSettings,
        onChangeImageData,
        onRemoveImage,
    } = props;

    const { prepareImageData, isValidImage } = useSimplicityImage();

    const url = image?.url;

    const [visible, setVisible] = useState(false);

    const onChangeImageWithSettings = async (image, settings) => {
        // const image_data = await prepareImageData(image, settings)
        // onChangeImageData(image_data)
        if (!image) {
            Logger.debug("remove image in onChangeImage");
        } else if (isValidImage(image)) {
            const image_data = await prepareImageData(image, settings);
            onChangeImageData(image_data);
        } else {
            Logger.error("Image supplied in onChangeImage was not a valid image.");
        }
    };

    return (
        <>
            <div className='component-editor-image-container'>

                {/* this is the small thumbnail in page - which is part of the carousel component editor */}
                {url &&
                    <ImageSelectorDisplay
                        image={image}
                        setOpen={setVisible}
                    />
                }

                {!url &&
                    <ImageSelectorButton
                        setOpen={setVisible}
                    />
                }
            </div>

            <CarouselImageSettingsDialog
                visible={visible}
                setVisible={setVisible}
                image={image}
                settings={settings}
                onChangeImageWithSettings={onChangeImageWithSettings}
                onRemoveImage={onRemoveImage}
                setImage={setImage}
                setSettings={setSettings}
            />
        </>
    );
};

export { CarouselImageEditor };
